<div class='{{nodeType}} node-level-{{nodeLevel}} node wrapper-node' [ngClass]="{'last-child': isLastChild}">
  <!--  Po Node Level-->
  <div class="node-row" [appHover]>
    <div class="product-name">
      <span (click)='onClick()' class='clickable' *ngIf='expandable ; else not_expandable'>
        <sfc-icon name="{{expanded ? 'rds-icon-chevron-up' : 'rds-icon-chevron-down'}}"
                  class='arrow expandable' [ngClass]="{'open-button': expanded}" size="xs">
        </sfc-icon>
        <span [ngClass]="{'open-text': expanded, 'detail-screen-nav': data.screenLinkIdFlag}"
              (click)="data.screenLinkIdFlag ? loadDetailPage(): null">{{data.product}}</span>
        <span appMeatBallMenu
              [meatBallMenuTitle]="'Product Service'"
              [requestRequiredData]="loadProductServicesRequiredData()"
              [hasBOCockpit]="data.hasBoCockpit"
              [hasMijnWonen]="data.administrationCode === '03'"
              [hasGeldOver]="data.administrationCode === '02' || data.administrationCode === '04' "
              *ngIf='data.hasProductServices || data.hasBoCockpit || hasOtherLinks.includes(data.administrationCode)'
              [attr.id]="data.iban ? data.iban : data.arrangementNumber"
              class='product-service-menu'>
              <sfc-icon name="rds-icon-three-dots-horizontal" size="sm" class='prod-serv-icon'></sfc-icon>
        </span>
      </span>
      <ng-template #not_expandable>
        <span class='not-expandable' [ngClass]="{'detail-screen-nav': data.screenLinkIdFlag}"
              (click)="data.screenLinkIdFlag ? loadDetailPage(): null">{{data.product}}</span>
        <span appMeatBallMenu
              [meatBallMenuTitle]="'Product Service'"
              [requestRequiredData]="loadProductServicesRequiredData()"
              [hasBOCockpit]="data.hasBoCockpit"
              [hasMijnWonen]="data.administrationCode === '03'"
              [hasGeldOver]="data.administrationCode === '02' || data.administrationCode === '04' "
              *ngIf='data.hasProductServices || data.hasBoCockpit || hasOtherLinks.includes(data.administrationCode)'
              [attr.id]="data.iban ? data.iban : data.arrangementNumber"
              class='product-service-menu'>
              <sfc-icon mat-icon-button  name="rds-icon-three-dots-horizontal" size="sm" class='prod-serv-icon'></sfc-icon>
        </span>
      </ng-template>
    </div>

    <div #data_row class='data-row'>
      <div class='data-field number'>{{data.count}}</div>
      <div class='data-field abb'></div>
      <div class='data-field arno'></div>
      <div class="data-field copy-btn"></div>
      <div class='data-field gap-button'><span></span></div>

      <div class="data-field saldo"
           [matTooltip]="data?.restrictedData ? data?.totalAmount : (data?.totalAmount | currency:'EUR':'symbol')"
           [matTooltipDisabled]="isBalanceToggle">

        <div *ngIf="isBalanceToggle" [ngClass]="{ red: (data?.totalAmount ?? 0) < 0 }">
          {{ data?.restrictedData ? (data?.totalAmount) : (data?.totalAmount | currency:'EUR':'symbol') }}
          {{ data?.totalAmount ? data?.totalAmountSuffix : null }}
        </div>

        <span *ngIf="!isBalanceToggle && data?.product !== 'Rabo OnlineKeys'">
          <sfc-icon name="rds-icon-padlock-closed" size="xs"></sfc-icon>
        </span>
      </div>

      <div class='data-field gap-button'><span></span></div>
      <div class='data-field gap-button'><span></span></div>
      <div class='data-field bank'>{{data.bankCode}}</div>
      <div class='data-field gap-button'><span></span></div>
      <div class='data-field specifics'></div>
      <div class='data-field status'></div>
      <div class='data-field relation'></div>
      <div class='expand-all'>
        <app-expand-all-button *ngIf='expandable' (click)="expandOrCollapseAll()" [allChildrenExpanded]="allExpanded"></app-expand-all-button>
      </div>
    </div>
  </div>
  <div [hidden]="!expanded" class='child-nodes'>
    <ng-container #po_node [appExpandAll]="allExpanded" [hostComponent]="this"></ng-container>
  </div>
</div>
